module.exports = __webpack_public_path__ + "8ee16b5f72b23c1c91596ce2121a0a6f.png";